import { Award, Cpu, ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";

const POINTS = [
  { n: "01", icon: Award, title: "Experienced Professionals", desc: "Skilled hands and real-world knowledge behind every remap and diagnostic job." },
  { n: "02", icon: Cpu, title: "Latest Equipment & Software", desc: "Up-to-date tools and tuning software for precise, reliable results every time." },
  { n: "03", icon: ShieldCheck, title: "Lifetime Software Warranty", desc: "Peace of mind as standard — our software work is backed for the life of the vehicle." },
];

export const WhyChooseUs = () => {
  return (
    <section id="why" data-testid="why-section" className="relative bg-brand-charcoal2 py-24 md:py-32 border-y border-brand-line">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_10%_0%,rgba(230,0,0,0.12),transparent_40%)]" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="flex items-center gap-3 text-brand-red font-semibold uppercase tracking-[0.35em] text-xs sm:text-sm mb-5">
            <span className="h-px w-10 bg-brand-red" /> Why Choose Us
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display italic font-extrabold uppercase tracking-tight text-white text-5xl sm:text-6xl md:text-7xl leading-[0.9] max-w-3xl mb-16">
            Built On <span className="text-brand-red">Trust</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-10 gap-y-14">
          {POINTS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.n} delay={i * 0.12}>
                <div data-testid={`why-point-${i}`} className="relative group">
                  <span className="font-display italic font-black text-white/[0.05] text-8xl md:text-9xl leading-none select-none block">
                    {p.n}
                  </span>
                  <div className="-mt-10 md:-mt-12 pl-1">
                    <Icon className="text-brand-red mb-4" size={30} strokeWidth={1.7} />
                    <h3 className="font-display italic font-bold uppercase tracking-tight text-white text-3xl md:text-4xl leading-none">
                      {p.title}
                    </h3>
                    <div className="h-0.5 w-12 bg-brand-red my-5 group-hover:w-20 transition-[width] duration-300" />
                    <p className="text-brand-offwhite/60 text-sm md:text-base leading-relaxed max-w-xs">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
